import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { GetAllReferencesResponse, referencesApi } from 'app/services/edpApiV1/references';
import { TReferencesInfo } from 'shared/types/reference.types';

type TReferencesState = Omit<TReferencesInfo, 'consultant' | 'workingDaysPassed'>;

type References = {
  data: TReferencesState[];
  pagination: {
    size: number;
    page: number;
    total: number;
  };
};

const initialState: References = {
  data: [
    {
      id: 0,
      created: '',
      status: '',
      employee: {
        id: 0,
        name: '',
        lastName: '',
        middleName: '',
        personnelNumber: '',
        position: '',
        division: '',
      },
      hr: {
        id: 0,
        name: '',
        email: '',
        lastName: '',
        middleName: '',
      },
      accountant: {
        id: 0,
        name: '',
        lastName: '',
        middleName: '',
      },
      year: 0,
      monthsAmount: 0,
      gettingMethod: '',
      amount: 0,
      rejectionReason: '',
      comment: '',
      refType: {
        id: 0,
        name: '',
        department: '',
      },
    },
  ],
  pagination: {
    size: 10,
    page: 1,
    total: 0,
  },
};

export const referencesSlice = createSlice({
  name: 'references',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        referencesApi.endpoints.getAllReferences.matchFulfilled,
        (state, { payload }: PayloadAction<GetAllReferencesResponse>) => payload,
      )
      .addMatcher(referencesApi.endpoints.getAllReferences.matchRejected, () => initialState);
  },
});

const references = (state: RootState) => state.entities.references;
const getReferences = createSelector(references, state => state);

export const selectors = { getReferences };
export const actions = referencesSlice.actions;
export const reducer = referencesSlice.reducer;
